import React, { useState, useEffect } from 'react';
import "./EditarSolicitacao.css";
import { Form, Select, Button, message, Modal, Input, Table, Space, Descriptions } from 'antd';
import { DownOutlined, UpOutlined, CarOutlined, FileTextOutlined, NumberOutlined, ArrowLeftOutlined, CalendarOutlined, TagOutlined } from '@ant-design/icons';
import api from '../../../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import API_CONFIG from '../../../../config/api.config';

const { Option } = Select;

const EditarSolicitacao = () => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [form] = Form.useForm();
  const location = useLocation();
  const navigate = useNavigate();
  const [numeroSolicitacao, setNumeroSolicitacao] = useState(null);
  const [veiculos, setVeiculos] = useState([]);
  const [veiculoSelecionado, setVeiculoSelecionado] = useState(null);
  const [itens, setItens] = useState([]);
  const [modalItemVisivel, setModalItemVisivel] = useState(false);
  const [itemEditando, setItemEditando] = useState(null);
  const [ItemInput, setItemInput] = useState("");
  const [quantidadeInput, setQuantidadeInput] = useState("");
  const [descricaoInput, setDescricaoInput] = useState("");
  const [linhaExpandida, setLinhaExpandida] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const [solicitacao, setSolicitacao] = useState(null);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [loading, setLoading] = useState(false);

  // Verificar autenticação ao montar o componente
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/login');
      return;
    }

    // Verificar se tem dados da solicitação
    if (!location.state?.solicitacao) {
      message.error('Dados da solicitação não encontrados.');
      navigate('/adm/solicitacoes');
      return;
    }
  }, [location.state, navigate]);

  // Carregar dados da solicitação ao montar o componente
  useEffect(() => {
    if (location.state?.solicitacao) {
      const solicitacaoData = location.state.solicitacao;
      setSolicitacao(solicitacaoData);
      setNumeroSolicitacao(solicitacaoData.SOL_ID);
      setVeiculoSelecionado(solicitacaoData.SOL_VEI_ID);
      
      // Buscar itens da solicitação via API
      buscarItensSolicitacao(solicitacaoData.SOL_ID);
    }
  }, [location.state]);

  const buscarItensSolicitacao = async (solicitacaoId) => {
    try {
      setLoading(true);
      const response = await api.get(API_CONFIG.ENDPOINTS.SOLICITACOES.ITENS(solicitacaoId));
      
      if (response.data.status && response.data.solicitacao) {
        const dadosSolicitacao = response.data.solicitacao;
        if (dadosSolicitacao.itens) {
          const itensFormatados = dadosSolicitacao.itens.map(item => ({
            nomeItem: item.IT_NOME,
            quantidade: item.IT_QUANTIDADE || 1,
            descricao: item.IT_DESCRICAO || '',
            id: item.IT_ID, // Adicionar o ID para identificar itens existentes
            EXCLUIR: item.EXCLUIR || 'NAO' // Adicionar o campo EXCLUIR
          }));
          setItens(itensFormatados);
        }
      }
    } catch (error) {
    //  console.error('Erro ao buscar itens da solicitação:', error);
      if (error.response?.status === 401) {
        message.error('Sessão expirada. Por favor, faça login novamente.');
        navigate('/login');
      } else {
        message.error('Erro ao carregar itens da solicitação');
      }
    } finally {
      setLoading(false);
    }
  };

  // Buscar veículos ao montar
  useEffect(() => {
    const buscarVeiculos = async () => {
      try {
        const response = await api.get(API_CONFIG.ENDPOINTS.VEICULOS.VEICULO_PREFEITURA(solicitacao?.SOL_PRE_ID));
        if (response.data.status) {
          const veiculosFormatados = response.data.veiculos.map(veiculo => ({
            id: veiculo.VEI_ID,
            nome: `${veiculo.VEI_DESCRICAO} - ${veiculo.VEI_PLACA}`,
            descricao: veiculo.VEI_DESCRICAO,
            placa: veiculo.VEI_PLACA,
            tipo: veiculo.VEI_TIPO,
            marca: veiculo.VEI_MARCA,
            modelo: veiculo.VEI_MODELO,
            ano: veiculo.VEI_ANO,
            chassi: veiculo.VEI_CHASSI
          }));
          setVeiculos(veiculosFormatados);
        }
      } catch (error) {
      //  console.error('Erro ao buscar veículos:', error);
        message.error('Erro ao carregar lista de veículos');
      }
    };

    if (solicitacao?.SOL_PRE_ID) {
      buscarVeiculos();
    }
  }, [solicitacao?.SOL_PRE_ID]);

  // Salvar alterações da solicitação
  const handleSalvarSolicitacao = async () => {
    const idSolicitacao = solicitacao?.SOL_ID;
    const idPrefeitura = solicitacao?.SOL_PRE_ID;
    const idUsuario = solicitacao?.SOL_USU_ID;
    const token = localStorage.getItem('token');

    if (!token) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/login');
      return;
    }

    if (!idPrefeitura || !idUsuario || !idSolicitacao) {
      message.error({
        content: 'Dados necessários não encontrados. Faça login novamente.',
        duration: 6,
        style: { fontSize: '1.2rem' }
      });
      return;
    }

    // Monta objeto apenas com campos alterados da solicitação principal
    const camposEditados = {};
    if (veiculoSelecionado !== solicitacao.SOL_VEI_ID) {
      camposEditados.SOL_VEI_ID = Number(veiculoSelecionado);
    }

    // Montar array de itens para enviar (inclui novos, editados e marcados para exclusão)
    let itensParaEnviar = [];

    // 2. Itens novos, editados ou marcados para exclusão (presentes no atual)
    itens.forEach(itemAtual => {
      if (itemAtual.EXCLUIR === "SIM") {
        // Já está marcado para exclusão, só envia isso
        itensParaEnviar.push({
          IT_ID: itemAtual.id,
          EXCLUIR: "SIM"
        });
      } else if (!itemAtual.id) {
        // Novo item, adicionar com detalhes
        itensParaEnviar.push({
          IT_ID: null,
          IT_NOME: itemAtual.nomeItem,
          IT_QUANTIDADE: Number(itemAtual.quantidade),
          IT_DESCRICAO: itemAtual.descricao || '',
          IT_STATUS: itemAtual.status || 'ABERTO',
          IT_COM_ID: itemAtual.IT_COM_ID || null
        });
      } else {
        // Item existente, verificar se foi editado
        const itemOriginal = solicitacao?.itens?.find(i => i.IT_ID === itemAtual.id);
        if (itemOriginal) {
          if (
            itemAtual.nomeItem !== itemOriginal.IT_NOME ||
            Number(itemAtual.quantidade) !== Number(itemOriginal.IT_QUANTIDADE) ||
            (itemAtual.descricao || '') !== (itemOriginal.IT_DESCRICAO || '')
          ) {
            // Item existente foi editado, adicionar com ID, COM_ID original e detalhes atualizados
            itensParaEnviar.push({
              IT_ID: itemAtual.id,
              IT_NOME: itemAtual.nomeItem,
              IT_QUANTIDADE: Number(itemAtual.quantidade),
              IT_DESCRICAO: itemAtual.descricao || '',
              IT_COM_ID: itemOriginal.IT_COM_ID
            });
          }
        }
      }
    });

    // Se não houver campos da solicitação editados nem itens para enviar, não faz nada
    if (Object.keys(camposEditados).length === 0 && itensParaEnviar.length === 0) {
      message.info('Nenhuma alteração detectada nos campos principais ou itens.');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...camposEditados,
        itens: itensParaEnviar
      };

      //console.log('Payload enviado:', payload); // Log para debug

      const response = await api.put(API_CONFIG.ENDPOINTS.SOLICITACOES.ATUALIZAR(idSolicitacao), payload);

      //console.log('Resposta da API:', response.data); // Log para debug da resposta

      if (response.data.status) {
        message.success({
          content: response.data.message || 'Solicitação atualizada com sucesso!',
          duration: 6,
          style: { fontSize: '1.2rem' }
        });
        navigate(`/adm/solicitacoes/${solicitacao.SOL_PRE_ID}`, { 
          state: { 
            abrirModalId: solicitacao.SOL_ID,
            nomePrefeitura: solicitacao.NOME_PREFEITURA 
          } 
        });
      } else {
        // Exibir mensagem de erro específica da API se disponível
        const errorMessage = response.data.message || 'Erro ao atualizar solicitação.';
        message.error({
          content: errorMessage,
          duration: 6,
          style: { fontSize: '1.2rem' }
        });
      }
    } catch (error) {
    //  console.error('Erro ao atualizar solicitação:', error.response?.data || error.message);
      const apiErrorMessage = error.response?.data?.message || 'Erro ao conectar com a API.';

      // Logar detalhes específicos do erro 422 se disponíveis
      if (error.response && error.response.status === 422 && error.response.data.errors) {
      //  console.error('Detalhes do erro de validação (422):', error.response.data.errors);
      }

      message.error({
        content: apiErrorMessage,
        duration: 6,
        style: { fontSize: '1.2rem' }
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  // Adicionar ou editar item
  const handleSalvarItem = () => {
    if (!ItemInput.trim()) {
      message.error('Informe o nome do Item.');
      return;
    }
    if (!quantidadeInput.trim()) {
      message.error('Informe a quantidade.');
      return;
    }
    if (itemEditando !== null) {
      // Editar - mantém os dados originais que não foram alterados
      const novosItens = [...itens];
      const itemOriginal = solicitacao?.itens?.find(item => item.IT_ID === novosItens[itemEditando].id);
      
      if (itemOriginal) {
        novosItens[itemEditando] = { 
          id: itemOriginal.IT_ID,
          nomeItem: ItemInput,
          quantidade: quantidadeInput,
          descricao: descricaoInput !== undefined ? descricaoInput : itemOriginal.IT_DESCRICAO,
          status: itemOriginal.IT_STATUS,
          dataVinculacao: itemOriginal.IT_DATA_VINCULACAO,
          IT_COM_ID: itemOriginal.IT_COM_ID
        };
      } else {
        // Se não encontrar o item original, mantém apenas os dados básicos
        novosItens[itemEditando] = { 
          nomeItem: ItemInput,
          quantidade: quantidadeInput,
          descricao: descricaoInput,
          status: 'ABERTO',
          dataVinculacao: new Date().toISOString()
        };
      }
      setItens(novosItens);
    } else {
      // Adicionar novo item
      setItens([...itens, { 
        nomeItem: ItemInput,
        quantidade: quantidadeInput,
        descricao: descricaoInput,
        status: 'ABERTO',
        dataVinculacao: new Date().toISOString(),
        IT_COM_ID: null
      }]);
    }
    setModalItemVisivel(false);
    setItemInput("");
    setQuantidadeInput("");
    setDescricaoInput("");
    setItemEditando(null);
  };

  // Remover item
  const handleRemoverItem = (idx) => {
    setItens(itens => {
      const item = itens[idx];
      // Se o item já existe no banco (tem id), marque para exclusão
      if (item.id) {
        return [
          ...itens.slice(0, idx),
          { ...item, EXCLUIR: "SIM" },
          ...itens.slice(idx + 1)
        ];
      }
      // Se for novo (não tem id), apenas remova da lista
      return itens.filter((_, i) => i !== idx);
    });
  };

  // Editar item
  const handleEditarItem = (idx) => {
    setItemInput(itens[idx].nomeItem);
    setQuantidadeInput(itens[idx].quantidade);
    setDescricaoInput(itens[idx].descricao || "");
    setItemEditando(idx);
    setModalItemVisivel(true);
  };

  // Adicionar novo item
  const handleAdicionarItem = () => {
    setItemInput("");
    setItemEditando(null);
    setModalItemVisivel(true);
  };

  // Adicionar função handleVoltar se não existir
  const handleVoltar = () => {
    navigate(`/adm/solicitacoes/${solicitacao?.SOL_PRE_ID}`, { 
      state: { 
        abrirModalId: solicitacao?.SOL_ID,
        nomePrefeitura: solicitacao?.NOME_PREFEITURA
      } 
    });
  };

  // Definição das colunas base
  const columnsBase = [
    {
      title: 'Nº',
      dataIndex: 'numero',
      key: 'numero',
      render: (_, __, idx) => idx + 1,
      width: 60
    },
    {
      title: 'Nome do Item',
      dataIndex: 'nomeItem',
      key: 'nomeItem',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      key: 'quantidade',
      width: 120
    }
  ];

  const columnsAcoes = {
    title: '',
    key: 'acoes',
    width: 220,
    render: (_, __, idx) => {
      if (!modoEdicao) return null;
      const excluido = itens[idx]?.EXCLUIR === "SIM";
      return (
        <Space>
          <Button onClick={() => handleEditarItem(idx)} disabled={excluido}>Editar</Button>
          <Button danger onClick={() => handleRemoverItem(idx)} disabled={excluido}>Remover</Button>
          <Button
            type="default"
            className="visualizar-btn"
            onClick={() => {
              setLinhaExpandida(linhaExpandida[0] === idx ? [] : [idx]);
            }}
            disabled={excluido}
          >
            {linhaExpandida[0] === idx ? 'Fechar' : 'Visualizar'}
          </Button>
          
        </Space>
      );
    }
  };

  const columns = modoEdicao ? [...columnsBase, columnsAcoes] : columnsBase;

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Editar Solicitação</h1>
        <div className="modal-content">
          <div className="editar-solicitacao-pre-header-box">
            <div className="editar-solicitacao-pre-header-numero">
              <FileTextOutlined style={{ fontSize: 24, color: '#001f4d' }} />
              Nº da solicitação: <span>{solicitacao?.SOL_ID || '...'}</span>
            </div>
            
            <div className="editar-solicitacao-pre-header-info">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label={<span><CalendarOutlined /> Data de Abertura</span>}>
                  {solicitacao?.SOL_DATA_VINCULACAO ? new Date(solicitacao.SOL_DATA_VINCULACAO).toLocaleDateString('pt-BR') : '-'}
                </Descriptions.Item>
              </Descriptions>

              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label={<span><TagOutlined /> Status</span>}>
                  {solicitacao?.SOL_STATUS || '-'}
                </Descriptions.Item>
              </Descriptions>
            </div>

            <div className="editar-solicitacao-pre-header-veiculo">
              <CarOutlined style={{ fontSize: 24, color: '#001f4d' }} />
              <span className="veiculo-label" style={{ fontWeight: 600 }}>Veículo:</span>
              <Select
                style={{ width: '100%' }}
                placeholder="Selecione o veículo"
                value={veiculoSelecionado}
                onChange={setVeiculoSelecionado}
                suffixIcon={<DownOutlined style={{ fontSize: 16, color: '#001f4d' }} />}
                dropdownStyle={{ 
                  borderRadius: '8px',
                  boxShadow: '0 3px 12px rgba(0,0,0,0.1)'
                }}
                disabled={!modoEdicao}
              >
                {veiculos.map(veiculo => (
                  <Option key={veiculo.id} value={veiculo.id}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CarOutlined style={{ fontSize: 16, color: '#001f4d' }} />
                      {veiculo.nome}
                    </div>
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          {modoEdicao && (
            <div style={{ textAlign: 'right', marginBottom: 12 }}>
              <Button type="primary" onClick={handleAdicionarItem} className="submit-adicionar" style={{ backgroundColor: '#008026' }}>
                Adicionar Item
              </Button>
            </div>
          )}
          {isMobile ? (
            <div className="tabela-mobile">
              {itens.map((item, idx) => (
                <div className={`tabela-mobile-item ${modoEdicao && item.EXCLUIR === "SIM" ? "item-excluido" : ""}`} key={idx}>
                  <div className="item-nome">{item.nomeItem}</div>
                  <div className="item-quantidade">Quantidade: {item.quantidade}</div>
                  {modoEdicao && item.EXCLUIR === "SIM" && (
                    <div className="item-excluido-msg">Item marcado para exclusão</div>
                  )}
                  {modoEdicao && (
                    <div className="item-botoes">
                      <Button onClick={() => handleEditarItem(idx)} size="small" disabled={item.EXCLUIR === "SIM"}>Editar</Button>
                      <Button danger onClick={() => handleRemoverItem(idx)} size="small" disabled={item.EXCLUIR === "SIM"}>Remover</Button>
                      <Button
                        type="default"
                        className="visualizar-btn"
                        size="small"
                        onClick={() => {
                          setLinhaExpandida(linhaExpandida[0] === idx ? [] : [idx]);
                        }}
                        disabled={item.EXCLUIR === "SIM"}
                      >
                        {linhaExpandida[0] === idx ? 'Fechar' : 'Visualizar'}
                      </Button>
                    </div>
                  )}
                  {linhaExpandida[0] === idx && (
                    <>
                      {item.descricao && (
                        <div className="item-descricao">{item.descricao}</div>
                      )}
                      <div className="detalhe-expandido-item" style={{ marginTop: 8 }}>
                        <div className="col-esq">
                          <div>
                            <span className="label-icone"><FileTextOutlined /> Nome do item:</span>
                            <div className="valor-destaque">{item.nomeItem}</div>
                          </div>
                          <div>
                            <span className="label-icone"><NumberOutlined /> Quantidade:</span>
                            <div className="valor-destaque">{item.quantidade}</div>
                          </div>
                        </div>
                        <div className="col-dir">
                          <span className="label-icone"><FileTextOutlined /> Descrição:</span>
                          <div className="descricao-expandida">{item.descricao || '-'}</div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={itens}
              pagination={false}
              rowKey={(_, idx) => idx}
              style={{ background: 'white', marginBottom: 24, clear: 'both' }}
              className="tabela-solicitacao"
              rowClassName={(_, idx) => (modoEdicao && itens[idx]?.EXCLUIR === "SIM" ? "item-excluido" : "")}
              expandable={{
                expandedRowRender: (record) => (
                  <div className="detalhe-expandido-item">
                    <div className="col-esq">
                      <div>
                        <span className="label-icone"><FileTextOutlined /> Nome do item:</span>
                        <div className="valor-destaque">{record.nomeItem}</div>
                      </div>
                      <div>
                        <span className="label-icone"><NumberOutlined /> Quantidade:</span>
                        <div className="valor-destaque">{record.quantidade}</div>
                      </div>
                    </div>
                    <div className="col-dir">
                      <span className="label-icone"><FileTextOutlined /> Descrição:</span>
                      <div className="descricao-expandida">{record.descricao || '-'}</div>
                    </div>
                  </div>
                ),
                expandedRowKeys: linhaExpandida,
                onExpand: (expanded, record, index) => {
                  // Não faz nada aqui, pois o controle é feito pelo botão Visualizar
                },
                showExpandColumn: false
              }}
            />
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 24 }}>
            <Button
              className="editar-submit-button"
              type="primary"
              icon={<ArrowLeftOutlined />}
              onClick={handleVoltar}
              style={{ minWidth: 120, fontWeight: 500, background: '#001f4d', border: 'none' }}
            >
              Voltar
            </Button>
            {!modoEdicao && solicitacao?.SOL_STATUS === "ABERTA" ? (
              <Button
                className="editar-submit-button"
                type="primary"
                icon={<FileTextOutlined />}
                onClick={() => setModoEdicao(true)}
                style={{ minWidth: 140 }}
              >
                Editar
              </Button>
            ) : null }
            {modoEdicao && (
              <Button type="primary" onClick={handleSalvarSolicitacao} className="editar-submit-button" style={{ minWidth: 140 }}>
                Salvar Alterações
              </Button>
            )}
          </div>
        </div>
        <Modal
          title={itemEditando !== null ? 'Editar Item' : 'Adicionar Item'}
          open={modalItemVisivel}
          onOk={handleSalvarItem}
          onCancel={() => { 
            setModalItemVisivel(false); 
            setItemEditando(null);
            setItemInput("");
            setQuantidadeInput("");
            setDescricaoInput("");
          }}
          okText="Salvar"
          cancelText="Cancelar"
          width={600}
          centered
          maskClosable={true}
          destroyOnClose={true}
          afterClose={() => {
            setModalItemVisivel(false);
            setItemEditando(null);
            setItemInput("");
            setQuantidadeInput("");
            setDescricaoInput("");
          }}
          getContainer={false}
          style={{ position: 'relative' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Nome do Item *</label>
              <Input
                placeholder="Nome do Item"
                value={ItemInput}
                onChange={e => setItemInput(e.target.value)}
                maxLength={100}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Quantidade/Litros *</label>
              <Input
                placeholder="Quantidade/Litros"
                value={quantidadeInput}
                onChange={e => setQuantidadeInput(e.target.value)}
                type="number"
                min="1"
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Descrição</label>
              <Input.TextArea
                placeholder="Descrição do item"
                value={descricaoInput}
                onChange={e => setDescricaoInput(e.target.value)}
                maxLength={500}
                rows={4}
              />
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default EditarSolicitacao;